module.exports = (typeof globalThis === 'object' && globalThis)
  || (typeof window === 'object' && window);
